import React, { useState } from "react";

import "./styles.scss";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
} from "reactstrap";
import IconFMI from "../Icons/IconFMI";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const activeHome = window.location.pathname === "/";
  const activeWhoWeAre = window.location.pathname === "/quienes-somos";
  const activeContact = window.location.pathname === "/contacto";
  const activeMDD =
    window.location.pathname === "/master-de-direccion-deportiva";
  const activeMCD =
    window.location.pathname === "/diplomado-en-marketing-y-comunicacion";
  const activeFGD =
    window.location.pathname ===
    "/programa-introductorio-en-finanzas-y-gestion-para-deportistas";

  return (
    <Container fluid tag="header" className="py-1">
      <Navbar expand="lg" container="lg">
        <NavbarBrand href="/" className="d-flex align-items-center">
          <IconFMI width={29} height={29} />
          <span className="ms-1">
            <strong>The Football Management Institute</strong> <hr /> Madrid
          </span>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto text-center text-lg-start" navbar>
            <NavItem>
              <NavLink href="/" active={activeHome}>
                TheFMI
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/quienes-somos" active={activeWhoWeAre}>
                Quiénes somos
              </NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className={"dropdown-active"}>
                Nuestros Programas
              </DropdownToggle>
              <DropdownMenu left className="text-center">
                <DropdownItem>
                  <NavLink
                    href="/master-de-direccion-deportiva"
                    active={activeMDD}
                  >
                    Master Dirección Deportiva
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink
                    href="/diplomado-en-marketing-y-comunicacion"
                    active={activeMCD}
                  >
                    Marketing y Comunicación digital
                  </NavLink>
                </DropdownItem>
                <DropdownItem>
                  <NavLink
                    href="/programa-introductorio-en-finanzas-y-gestion-para-deportistas"
                    active={activeFGD}
                  >
                    Finanzas y Gestión Deportiva
                  </NavLink>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink href="/contacto" active={activeContact}>
                Formulario de Inscripción
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="mailto:info@thefmimadrid.com" className="nav-mail">
                info@thefmimadrid.com
              </NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </Container>
  );
};

export default NavBar;
